import type { RecordRelayClient } from '@fiit/record-relay';
import { createRecordRelayClient } from '@fiit/record-relay';
import { getSessionId } from 'app/utils/analytics/recordrelay/session';

let client: RecordRelayClient | null = null;

type InitRecordRelayParams = {
  baseUrl: string;
  apiKey: string;
  userId: string;
  countryCode?: string;
};

export const initRecordRelay = ({ baseUrl, apiKey, userId, countryCode }: InitRecordRelayParams): void => {
  client = createRecordRelayClient({
    baseUrl,
    writeKey: apiKey,
    userId,
    app: 'hyrox-app',
    countryCode,
    sessionId: getSessionId(),
  });
};

export const getRecordRelayClient = (): RecordRelayClient | null => client;
